import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const SocialField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout direction="row">
      <FormInput
        name={`socialNetworks.${index}.socialNetworkType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormInput name={`socialNetworks.${index}.socialNetwork`} placeholder="@ username" />
    </FieldLayout>
  );
};
